import { useQuery } from '@tanstack/react-query';
import {
  InvestigationsCaseResponse,
  InvestigationsPayload,
} from 'app/modules/investigations/types';
import { CachedInvestigationsCaseResponse } from 'app/modules/investigations/types/responses';
import { useSelector } from 'react-redux';
import { selectHasReadCasesPermissions } from 'app/modules/session/selectors';
import { CASE_QUERY_KEYS } from 'app/modules/cases/queries/keys';
import { selectDLEnabledForCaseList } from 'app/shared/featureFlags/selectors';
import { post } from 'app/shared/utils/fetchr';

interface Options {
  enabled?: boolean;
  staleTime?: number;
}

const retrieveInvestigationsCases = <TResponse>(
  payload: InvestigationsPayload,
) => {
  // DEPRECATED we are transitioning to the new cached endpoint
  return post<TResponse>('/v1/investigations/retrieve/case-list', payload);
};

export const useListCases = (
  payload: InvestigationsPayload,
  options?: Options,
) => {
  const hasReadCasesPermission = useSelector(selectHasReadCasesPermissions);
  const useNewEndpoint = useSelector(selectDLEnabledForCaseList);

  return useQuery({
    queryKey: CASE_QUERY_KEYS.listCases({
      payload,
      useCacheEndpoint: useNewEndpoint,
    }),
    queryFn: () =>
      useNewEndpoint
        ? post<CachedInvestigationsCaseResponse>(
            '/v1/cases/cached/list',
            payload.object_filters,
          )
        : retrieveInvestigationsCases<InvestigationsCaseResponse>(payload),
    enabled: hasReadCasesPermission && options?.enabled !== false,
    staleTime: options?.staleTime,
  });
};
